var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"About"},[_c('b-form-select',{staticClass:"mt-3",attrs:{"options":_vm.options,"size":"sm"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}),_c('button',{on:{"click":function($event){_vm.counter += 1}}},[_vm._v("Submit")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }